import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { AuthService } from './services/auth.service';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, filter, take, switchMap } from 'rxjs/operators';
import { AuthFacade } from './facades/auth.facade';
import { Router } from '@angular/router';
import { NotificationService } from '@cradua/core';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(
    public authService: AuthService,
    public authFacade: AuthFacade,
    private router: Router,
    private notification: NotificationService,
    ) {

   }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
   request = this.setSSOHeader(request);
    this.authFacade.getLoginUser;
    if (this.authService.getJwtToken()) {
      request = this.addToken(request, this.authService.getJwtToken());
    }

    return next.handle(request).pipe(catchError(error => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        localStorage.removeItem('LoggedInUser');
        localStorage.removeItem('Application');
        localStorage.removeItem('AssignedRoles');
        localStorage.removeItem('REFRESH_TOKEN');
        localStorage.removeItem('JWT_TOKEN');
        localStorage.removeItem('Link');
        localStorage.removeItem('userRoles');
        this.authService.isLoggedIn$.next(false);
        this.notification.success("Your access has expired, please login again");
        this.router.navigate(['/auth/login']);
        return this.handle401Error(request, next);
      } else {
        return throwError(error);
      }
    }));
  }

  private addToken(request: HttpRequest<any>, token: string) {

    // console.log(`Token Gotten${token}`);
    return request.clone({
      setHeaders: {
        'Authorization': `Bearer ${token}`
      }
    });
  }


  private setSSOHeader(request: HttpRequest<any>) {
    return request.clone({
      withCredentials: true,
    });
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      return this.authService.refreshToken().pipe(
        switchMap((token: any) => {
          this.isRefreshing = false;
          this.refreshTokenSubject.next(token.jwt);
          return next.handle(this.addToken(request, token.jwt));
        }));

    } else {
      return this.refreshTokenSubject.pipe(
        filter(token => token != null),
        take(1),
        switchMap(jwt => {
          return next.handle(this.addToken(request, jwt));
        }));
    }
  }
}
